export const useBookmakerLogo = (logoUrl: string | undefined) => {
  if (!logoUrl) {
    return '';
  }

  const url = new URL(logoUrl);
  url.searchParams.append('fm', 'webp');
  url.searchParams.append('w', '190'); // double rendered size

  return url.toString();
};
